// Приветственная полоса для гостя над доской: объясняет, что перед ним, и
// зовёт завести аккаунт. Вместо отдельного лендинга: лучшая витрина продукта —
// сама доска с демо-поездкой, которую можно трогать без регистрации.
import { useState, type ReactElement } from 'react';
import { useAuth } from '../../auth';
import { useT } from '../../i18n';
import styles from './GuestHero.module.css';

/** Версия в ключе: изменится подача — полосу можно показать заново. */
const DISMISS_KEY = 'plan-flights.heroDismissed.v1';

function readDismissed(): boolean {
  try {
    return window.localStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
}

export function GuestHero(): ReactElement | null {
  const { isGuest, requestSignIn, status } = useAuth();
  const t = useT();
  const [dismissed, setDismissed] = useState(readDismissed);

  // Пока авторизация грузится, полоса не мигает; вошедшему она не нужна.
  if (status === 'loading' || !isGuest || dismissed) return null;

  function dismiss(): void {
    setDismissed(true);
    try {
      window.localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // Приватный режим без localStorage: полоса скроется до перезагрузки.
    }
  }

  return (
    <section className={styles.hero} aria-label={t('hero.title')}>
      <div className={styles.textWrap}>
        <h2 className={styles.title}>{t('hero.title')}</h2>
        <p className={styles.lead}>{t('hero.lead')}</p>
      </div>
      <div className={styles.actions}>
        <button type="button" className="btn btn-primary" onClick={requestSignIn}>
          {t('hero.signup')}
        </button>
        <button type="button" className="btn" onClick={dismiss}>
          {t('hero.try')}
        </button>
      </div>
    </section>
  );
}
